export default "__VITE_ASSET__Cm3A2Pap__"